import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=6d90d4b5&"
import script from "./input-text.component.ts?vue&type=script&lang=ts&"
export * from "./input-text.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports